// ============================================================================
// CrewAhead Route Guard Utilities
// Shared role/path helpers used by middleware, server guards, and auth helpers.
// ============================================================================

import { ROLES } from './constants';

export type UserRole = (typeof ROLES)[keyof typeof ROLES];

export function getDashboardForRole(role: string | undefined | null): string {
  switch (role) {
    case ROLES.EMPLOYER:
      return '/employer';
    case ROLES.SEAFARER:
      return '/seafarer';
    case ROLES.SHORE:
      return '/shore';
    case ROLES.INSTITUTE:
      return '/institute';
    case ROLES.ADMIN:
      return '/admin';
    default:
      return '/login';
  }
}

export function getRoleFromPath(pathname: string): string | null {
  if (
    pathname.startsWith('/dashboard/employer') ||
    pathname === '/employer' ||
    pathname.startsWith('/employer/')
  ) {
    return ROLES.EMPLOYER;
  }

  if (
    pathname.startsWith('/dashboard/seafarer') ||
    pathname === '/seafarer' ||
    pathname.startsWith('/seafarer/')
  ) {
    return ROLES.SEAFARER;
  }

  if (
    pathname.startsWith('/dashboard/shore') ||
    pathname === '/shore' ||
    pathname.startsWith('/shore/')
  ) {
    return ROLES.SHORE;
  }

  if (
    pathname.startsWith('/dashboard/institute') ||
    pathname === '/institute' ||
    pathname.startsWith('/institute/')
  ) {
    return ROLES.INSTITUTE;
  }

  if (
    pathname.startsWith('/dashboard/admin') ||
    pathname === '/admin' ||
    pathname.startsWith('/admin/')
  ) {
    return ROLES.ADMIN;
  }

  return null;
}

export function isRoleAllowedForPath(
  role: string | undefined | null,
  pathname: string
): boolean {
  const requiredRole = getRoleFromPath(pathname);
  if (!requiredRole) return true;
  return requiredRole === role;
}
